export const TASKS_REQUEST = 'TASKS_REQUEST';
export const TASKS_RECEIVE = 'TASKS_RECEIVE';
export const TASKS_ERROR = 'TASKS_ERROR';
export const TASKS_INVALIDATE = 'TASKS_INVALIDATE';
export const TASKS_SET_VIEWED = 'TASKS_SET_VIEWED';



// WEBPACK FOOTER //
// ./src/store/tasks/actionTypes.js